module.exports = __webpack_public_path__ + "img/icon-pull-copy.5293c6cb.svg";